<script lang="ts" setup>
  import Link from "@/components/ui/link/Link.vue"
</script>

<template>
  <h4>We understand price is always important</h4>
  <p>
    We pride ourselves on offering competitive tariffs, and we may be able to
    find ways for you to pay less. If you'd like to discuss this further, please
    contact our friendly team by emailing
    <Link class="link text-primary-600" to="mailto:help@so.energy"
      >help@so.energy</Link
    >
    or using the online chat (available weekdays, 9am-5pm). Otherwise, you can
    proceed to cancel your switch.
  </p>
</template>
